import React from 'react'
import { injectIntl, InjectedIntlProps } from 'gatsby-plugin-intl'
import LinkButton from '../LinkButton'
import Center from '../Layout/Center'

type Props = InjectedIntlProps

const faqMenu = ({ intl: { formatMessage } }: Props) => {
  return (
    <Center className="u-mt-lg">
      <p className="u-mb-lg">{formatMessage({ id: 'faq.noAnswer' })}</p>
      <LinkButton to={`/a-propos/contact`} color="secondary">
        {formatMessage({ id: 'common.contact' })}
      </LinkButton>
    </Center>
  )
}

export default injectIntl(faqMenu)
